export const ROLES = {
  client: "client",
  carer: "carer",
  instructor: "training_instructor",
  admin: "admin",
  coordinator: "carer_coordinator",
  superAdmin: "system_admin",
}

 
// ====================== New Roles: Used in header to show role label correctly for different roles ======================
export const NEW_ROLES = [
  {
    name: "client",
    label: "Client"
  },
  {
    name: "carer",
    label: "Carer"
  },
  {
    name: "training_instructor",
    label: "Instructor"
  },
  {
    name: "admin",
    label: "Admin"
  },
  {
    name: "carer_coordinator",
    label: "Coordinator"
  },
  {
    name: "system_admin",
    label: "System Admin"
  }
]